module.exports = __webpack_public_path__ + "img/shuibeng2.f14a0266.gif";